import { ButtonType } from '@thiememeulenhoff/types';
import { html, nothing } from 'lit';
import { property } from 'lit/decorators.js';
import { TmElement } from '../../custom-element.helper';

export abstract class AnchorElement extends TmElement {
  @property({ type: String })
  href?: string;

  @property({ type: String })
  target?: string;

  @property({ type: Boolean })
  disabled = false;

  @property({ type: String })
  type: ButtonType = 'button';

  constructor() {
    super();
    this.attachShadow({ mode: 'open', delegatesFocus: true });
  }

  protected onSlotChanged() {
    // Can be overwritten
  }

  override render() {
    if (this.href) {
      return html`<a
        part="button"
        class="button"
        href=${this.disabled ? nothing : this.href}
        target=${this.target ?? nothing}
        ?disabled=${this.disabled}
        data-test="anchor"
      >
        <slot @slotchange=${this.onSlotChanged}></slot>
      </a>`;
    }

    return html`<button
      part="button"
      class="button"
      ?disabled=${this.disabled}
      type=${this.type}
      @click=${this.handleClick}
      data-test="button"
    >
      <slot @slotchange=${this.onSlotChanged}></slot>
    </button>`;
  }

  handleClick = (event: MouseEvent) => {
    this.dispatchLocalEvent({
      eventName: 'clicked',
      detail: event,
    });
  };
}
